import { render, staticRenderFns } from "./TeamLeaderFeedback.vue?vue&type=template&id=5ab01ae0"
import script from "./TeamLeaderFeedback.vue?vue&type=script&lang=js"
export * from "./TeamLeaderFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports